import { Icon, IconType } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { NotificationBadge } from 'src/components/NotificationBadge';
import { useNotificationBadgeData } from 'src/hooks/useNotificationBadgeData';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';

import { SidebarItem, SidebarItemClasses } from './layoutPreviewTypes';

const useStyles = makeStyles()((theme) => ({
  root: {
    height: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: '-webkit-fill-available',
    alignItems: 'center',
    padding: theme.spacing(0, 0.5),
    borderRadius: theme.shape.borderRadius,
  },
  itemIcon: {
    fontSize: 8,
  },
  itemText: {
    marginLeft: theme.spacing(1),
    fontSize: 8,
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '72px',
    textOverflow: 'ellipsis',
  },
  itemTextWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  active: {
    backgroundColor: theme.palette.primary.dark,
  },
}));

interface SidebarItemPreviewProps {
  item: SidebarItem;
  classes: SidebarItemClasses;
}

export const SidebarItemPreview: React.FC<SidebarItemPreviewProps> = ({
  item,
  classes,
}) => {
  const { classes: defaultClasses } = useStyles();

  const { backgroundColor, textColor } = useNotificationBadgeData(true);

  return (
    <div
      className={clsx(defaultClasses.root, classes.item, {
        [classes.itemActive || defaultClasses.active]: item.active,
      })}
    >
      <div className={defaultClasses.itemTextWrapper}>
        {item.iconName ? (
          <Icon
            icon={item.iconName as IconType}
            className="h-[10px] w-[10px]"
          />
        ) : item.icon ? (
          <item.icon className={defaultClasses.itemIcon} />
        ) : null}
        <BaseTypography className={defaultClasses.itemText}>
          {item.title}
        </BaseTypography>
      </div>
      {item.notificationCount && (
        <NotificationBadge
          content={item.notificationCount}
          isSidebar
          backgroundColor={backgroundColor}
          textColor={textColor}
        />
      )}
    </div>
  );
};
